module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mobile-404_a239cb.jpg";